var path = '/assets/js/dashboard/financials/reporting/_common/downloadFile/downloadFile.html';
var html = "<a ng-click=\"$ctrl.download()\">\n    <ng-transclude></ng-transclude>\n</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;